import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmDeleteTemplateModal = ({ show, onConfirm, onCancel, templateTitle }) => {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete Template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete "{templateTitle || 'this template'}"? This action cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteTemplateModal;

